import Select from '@/components/DSE/Select';
import { validatorRequireNumber } from '@/utils/validators';

export function getFormDefinition(vue) {
  return {
    collectionID: {
      type: Select,
      props: {
        caption: 'store.collection',
        valueField: 'id',
        labelField: 'description',
        loading: vue.$store.getters['collection/isLoading'],
        options: vue.$store.getters['collection/loadedItems']
      },
      rules: [{ validator: validatorRequireNumber }]
    }
  };
}
export default getFormDefinition;

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
